module.exports = __webpack_public_path__ + "img/borderThreeCircularCloudWhite.5e01a470.svg";